<template>
  <div>
    <div class="hvh-flex align-center mb-3">
      <v-icon @click="isExpanded = true" v-if="!isExpanded">mdi-plus-box-outline</v-icon>
      <v-icon @click="isExpanded = false" v-else>mdi-minus-box-outline</v-icon>
      <div class="ml-2">{{ group.key.toUpperCase() }}</div>
    </div>
    <div v-if="isExpanded">
      <div class="hvh-flex aling-center mb-3 pr-5 pl-3" v-for="option in group.items" :key="`${option.item.label}-${option.item.type}`">
        <CheckBox :value="isChecked(option.item)" @input="emitData(option.item)" />
        <span style="max-width:400px" class="clickable no-wrap ml-3" @click="emitData(option.item)">{{ filterDataDisplay(option)}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import CheckBox from '../../../common/form/checkbox/CheckBox.vue';
export default {
  components: { CheckBox },
  props: ['group', 'value'],
  data() {
    return { isExpanded: true };
  },
  methods: {
    filterDataDisplay(option){
      return `${option.item.procLabelRep||option.item.label}:
      ${option.item.type.startsWith("drug")?option.item.type.replace("drug",''):""}
       (${option.count })`;
    },
    emitData(item) {
      if (this.isChecked(item))
        this.$emit('input', (this.value || []).filter(f => !(f.label === item.label && f.type === item.type)));
      else
        this.$emit('input', [...(this.value || []), item]);
    },
    isChecked(item) {
      return (this.value || []).any(f => f.label === item.label && f.type === item.type);
    },
  },
}
</script>